import { observer } from 'mobx-react';

import keepPlayingWidgetImage from '../../../../assets/cash-offer/keep_playing_widget.png';
import { useStores } from '../../../../stores/useStores';
import type { CashOfferWidgetDataType, WidgetSizeType } from '../../types';
import { GeneralSmallWidget, GeneralWideWidget } from '../GeneralWidget';
import { WidgetWrapper } from '../WidgetWrapper/WidgetWrapper';

import styles from './CashOfferWidget.module.scss';

interface CashOfferWidgetProps {
  sizeType: WidgetSizeType;
  data: CashOfferWidgetDataType;
}

function CashOfferWidgetComponent({ data, sizeType }: CashOfferWidgetProps) {
  const { cashOfferStore } = useStores();

  const onClick = () => {
    cashOfferStore.openDialog();
  };

  return (
    <WidgetWrapper className={styles.widgetRoot} dataTestId={data.dataTestId} sizeType={sizeType} onClick={onClick}>
      {sizeType === 'small' ? (
        <GeneralSmallWidget widgetImageUrl={keepPlayingWidgetImage} />
      ) : (
        <GeneralWideWidget widgetImageUrl={keepPlayingWidgetImage} />
      )}
    </WidgetWrapper>
  );
}

export const CashOfferWidget = observer(CashOfferWidgetComponent);
